import { useAuthStore } from '@/shared/stores/authStore';

export function useAuth() {
  const user = useAuthStore((s) => s.user);
  const session = useAuthStore((s) => s.session);
  const organizationId = useAuthStore((s) => s.organizationId);
  const role = useAuthStore((s) => s.role);
  const isLoading = useAuthStore((s) => s.isLoading);
  const signOut = useAuthStore((s) => s.signOut);

  return {
    user,
    session,
    organizationId,
    role,
    isLoading,
    isAuthenticated: session !== null,
    signOut,
  };
}
